$(document).ready(function(){
    $('.slick-cta-scroll-control').slick({
        infinite: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
        arrows:true,
        prevArrow: '<p class="slick-prev"><i class="fas fa-chevron-left"></i></p>',
        nextArrow: '<p class="slick-next"><i class="fas fa-chevron-right"></i></p>',
        responsive: [
            {
                breakpoint: 3600,
                settings: {
                    slidesToShow: 13,
                }
            },
            {
                breakpoint: 3300,
                settings: {
                    slidesToShow: 12,
                }
            },
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow: 11,
                }
            },
            {
                breakpoint: 2700,
                settings: {
                    slidesToShow: 10,
                }
            },
            {
                breakpoint: 2400,
                settings: {
                    slidesToShow: 9,
                }
            },
            {
                breakpoint: 2100,
                settings: {
                    slidesToShow: 8,
                }
            },
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 7,
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
})

$(document).ready(function(){
    $('.slick-promoted-products-scroll-control .product-card').removeClass('show-before');

    $('.slick-promoted-products-scroll-control').on('init', function(event, slick){
        $('.slick-promoted-products-scroll-control .product-card').addClass('show-before');
    });

    $('.slick-promoted-products-scroll-control').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
        arrows:true,
        prevArrow: '<p class="slick-prev"><i class="fas fa-chevron-left"></i></p>',
        nextArrow: '<p class="slick-next"><i class="fas fa-chevron-right"></i></p>',
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
})

$(document).ready(function(){
    const $carousel = $('.homepage-hero-carousel');
    
    // Function to set items height based on content
    function setItemsHeight(slideIndex = 0) {
        // only below xl breakpoint
        if ($(window).width() > 1200) return;
        const $items = $carousel.find('.homepage-hero-carousel__items');
        const $activeItem = $carousel.find('.slick-slide[data-slick-index="' + slideIndex + '"]').find('.homepage-hero-carousel__items');
        const contentHeight = $activeItem.find('.container').outerHeight();
        $items.height(contentHeight);
        $items.parent('.container-fluid').height(contentHeight + 20);
        const firstChildHeight = $activeItem.find('.container > *').first().outerHeight();
        $carousel.find('.slick-prev').css('top', firstChildHeight + 40);
        $carousel.find('.slick-next').css('top', firstChildHeight + 40);
        $activeItem.find('.container').css('gap', 50);
    }

    $carousel.on('init', function() {
        setItemsHeight();
    });

    $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        setItemsHeight(nextSlide);
    });

    $carousel.slick({
        infinite: true,
        swipe: true,
        swipeToSlide: true,
        arrows: true,
        prevArrow: '<p class="slick-prev ms-4"><i class="fas fa-chevron-left"></i></p>',
        nextArrow: '<p class="slick-next me-4"><i class="fas fa-chevron-right"></i></p>',
    });

    // Update heights on window resize
    $(window).on('resize', function() {
        const currentSlide = $carousel.slick('slickCurrentSlide');
        setItemsHeight(currentSlide);
    });
})

window.addEventListener("load", () => {
    const video = document.getElementById("item-video");
    if (video) {
        const src = video.getAttribute('data-load-src');
        video.firstElementChild.src = src;
        video.load();
    }

});
